export default "__VITE_ASSET__b27781e4__"